import { Field, Form, Formik } from 'formik';
import { connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import LabelWithTick from '../../UI/LabelWithTick/helper';
import FormError from '../../UI/FormError';
import './styles.scss';
import { DatePicker } from 'antd';
import moment from 'moment';
import SourceCategoryForm from '../SourceCategoryForm/SourceCategoryForm';
import FileInput from 'components/AccountSettings/InventoryManagement/resolveDropDown/CustomComponents/FileInput/FileInput';
import {
  createMarketingNews,
  getMarketingNews,
  getMarketingSourcesAndCategories,
} from 'store/actions/MarketingNewsActions';
import defaultSourceLogo from '../../../assets/images/navigation/marketing.svg';

import { ALLOWED_NEWS_IMAGE_TYPES } from '../constants';
import Toast from 'components/AccountSettings/InventoryManagement/resolveDropDown/CustomComponents/Toast/Toast';
import checkBlue from '../../../assets/images/CheckBlue.svg';

const NewsSubmissionForm = ({
  closedText = 'Cancel',
  submitText = 'Submit',
  _handleClose,
  setSubmitSuccess,
  isSubmitSuccessful,
  footerClass = '',
  requirementFormClass = '',
  formRef,
  createMarketingNews,
  getMarketingSourcesAndCategories,
  marketingCategories,
  marketingSources,
}) => {
  const formContentRef = useRef();
  const [fieldAdded, setFieldAdded] = useState(false);
  const [openSource, setOpenSource] = useState('');
  const [toastVisible, setToastVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [sources, setSources] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [successText, setSuccessText] = useState('');

  const FORM_INITIAL_STATE = {
    title: '',
    description: '',
    image: null,
    category: '',
    // date: '',
    source: '',
    whatsappCount: 0,
    likesCount: 0,
    articleLink: '',
  };

  const ValidationSchema = Yup.object().shape({
    title: Yup.string()
      .required('Title is required')
      .max(250, 'Title must not exceed 250 characters'),
    description: Yup.string()
      .required('Description is required')
      .max(400, 'Description must not exceed 400 characters'),
    image: Yup.mixed().nullable().required('Please attach an image'),
    category: Yup.string().required('Select a category'),
    // date: Yup.date()
    //   .required('Date of publishing is required')
    //   .max(new Date(), 'Date cannot be in the future'),
    source: Yup.string().required('Select a source'),
    whatsappCount: Yup.number().min(0).required('Required'),
    likesCount: Yup.number().min(0).required('Required'),
    articleLink: Yup.string()
      .matches(/^https?:\/\/(www\.)?([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i, 'URL must be valid')
      .required('Article link is required'),
  });

  useEffect(() => {
    getMarketingSourcesAndCategories();
    setIsUpdated(false);
  }, [isUpdated]);

  useEffect(() => {
    setCategories(marketingCategories);
    setSources(marketingSources);
  }, [marketingCategories, marketingSources]);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      values.image = values.image.fileUrl;
      const payload = {
        ...values,
        category: Number(values.category),
        source: Number(values.source),
      };
      resetForm();
      await createMarketingNews(payload);
      handleItemAdd('Article created successfully');
    } catch (err) {
      console.error('Form submission error:', err);
    }
  };

  const handleItemAdd = (successText) => {
    setSuccessText(successText);
    setToastVisible(true);
  };

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={FORM_INITIAL_STATE}
        validationSchema={ValidationSchema}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}>
        {({ errors, touched, setFieldValue, values, handleChange, resetForm }) => {
          const formValidation =
            Object.keys(errors).length === 0 &&
            Object.values(values).every((v) => v !== '' && v !== null);

          return (
            <>
              <h1 className="News_Item_Heading">Add News</h1>
              <Form className={requirementFormClass + ' requirementContainer '}>
                <div className="requirementForm">
                  <div className="formContent" ref={formContentRef}>
                    <div className="field">
                      <LabelWithTick
                        label="Title"
                        withValidation={true}
                        isValid={values.title && !errors.title}
                        labelClass="label"
                      />
                      <Field type="text" name="title" placeholder="Enter news title" />
                      {touched.title && errors.title && (
                        <FormError error={errors.title} errorClass="field-error" />
                      )}
                      <p className="news_title_heading">
                        You can enter up to 250 characters in the news title
                      </p>
                    </div>

                    <div className="field">
                      <LabelWithTick
                        label="Description"
                        withValidation={true}
                        isValid={values.description && !errors.description}
                        labelClass="label"
                      />
                      <Field
                        as="textarea"
                        rows="4"
                        name="description"
                        placeholder="Enter news description"
                      />
                      {touched.description && errors.description && (
                        <FormError error={errors.description} errorClass="field-error" />
                      )}
                      <p className="news_title_heading">
                        You can enter up to 400 characters in the Description
                      </p>
                    </div>

                    {/* <div className="modalInpContainer dateInput">
                      <LabelWithTick
                        label="Date of Publishing"
                        withValidation={true}
                        isValid={values.date && !errors.date}
                        labelClass="label"
                      />
                      <DatePicker
                        className="date"
                        placeholder="Select Date"
                        value={values.date ? moment(values.date) : null}
                        onChange={(date, dateString) => {
                          setFieldValue('date', dateString);
                        }}
                      />
                      {touched.date && errors.date && (
                        <FormError error={errors.date} errorClass="field-error" />
                      )}
                    </div> */}

                    <div className="file-input-wrapper">
                      <FileInput
                        uploadButtonName="Attach Image"
                        name="image"
                        label="Attach Image"
                        isRequired={true}
                        resetUpload={!values['image']}
                        acceptFileType={ALLOWED_NEWS_IMAGE_TYPES}
                        isFullWidth={true}
                      />
                    </div>
                    <div className="field">
                      <LabelWithTick
                        label="Category"
                        withValidation={true}
                        isValid={values.category && !errors.category}
                        labelClass="label"
                      />
                      <div role="group" className="checkbox-group" aria-labelledby="checkbox-group">
                        {marketingCategories.map((cat) => (
                          <label key={cat.id} className="radioButton">
                            <Field type="radio" name="category" value={cat.id.toString()} />
                            <span>
                              <div className="news_category_radio_button">
                                {values.category == cat.id.toString() ? (
                                  <img src={checkBlue} />
                                ) : null}
                                {cat.newsCategoryName}
                              </div>
                            </span>
                          </label>
                        ))}
                        <button
                          type="button"
                          className="addSourceBtn"
                          onClick={() => setOpenSource('category')}>
                          + Add Category
                        </button>
                      </div>
                      {touched.category && errors.category && (
                        <FormError error={errors.category} errorClass="field-error" />
                      )}
                    </div>

                    <div className="field">
                      <LabelWithTick
                        label="Source"
                        withValidation={true}
                        isValid={values.source && !errors.source}
                        labelClass="label"
                      />
                      <div role="group" className="checkbox-group" aria-labelledby="checkbox-group">
                        {marketingSources.map((src) => (
                          <label key={src.id} className="radioButton">
                            <Field type="radio" name="source" value={src.id.toString()} />
                            <span className="source-option">
                              <img
                                src={src.sourceImageUrl || defaultSourceLogo}
                                alt={src.sourceName}
                                className="source-icon"
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = defaultSourceLogo;
                                }}
                              />
                              <p>{src.sourceName}</p>
                            </span>
                          </label>
                        ))}
                        <button
                          type="button"
                          className="addSourceBtn"
                          onClick={() => setOpenSource('source')}>
                          + Add Source
                        </button>
                      </div>
                      {touched.source && errors.source && (
                        <FormError error={errors.source} errorClass="field-error" />
                      )}
                    </div>

                    <div className="field">
                      <LabelWithTick
                        label="Article Link"
                        withValidation={true}
                        isValid={values.articleLink && !errors.articleLink}
                        labelClass="label"
                      />
                      <Field type="text" name="articleLink" placeholder="https://www.example.com" />
                      {touched.articleLink && errors.articleLink && (
                        <FormError error={errors.articleLink} errorClass="field-error" />
                      )}
                    </div>

                    <div className="field-row">
                      <div className="field half-width">
                        <LabelWithTick
                          label="Initial WhatsApp count"
                          withValidation={true}
                          isValid={values.whatsappCount >= 0 && !errors.whatsappCount}
                          labelClass="label"
                        />
                        <Field
                          type="number"
                          name="whatsappCount"
                          placeholder="Enter initial WhatsApp shares"
                        />
                        {touched.whatsappCount && errors.whatsappCount && (
                          <FormError error={errors.whatsappCount} errorClass="field-error" />
                        )}
                      </div>

                      <div className="field half-width">
                        <LabelWithTick
                          label="Initial Likes count"
                          withValidation={true}
                          isValid={values.likesCount >= 0 && !errors.likesCount}
                          labelClass="label"
                        />
                        <Field type="number" name="likesCount" placeholder="Enter initial likes" />
                        {touched.likesCount && errors.likesCount && (
                          <FormError error={errors.likesCount} errorClass="field-error" />
                        )}
                      </div>
                    </div>
                    <div className={'flex-center submit__container ' + footerClass}>
                      <button
                        type="submit"
                        className="btn btn-primary buttonWidth"
                        disabled={!formValidation}>
                        {submitText}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {openSource !== '' && (
        <div className="modal__container">
          <div className="news_modal_overlay">
            <div className="news_modal_content">
              <SourceCategoryForm
                closedText="Close"
                submitText="Add"
                _handleClose={() => {
                  setSubmitSuccess(false);
                  setOpenSource(false);
                }}
                isSubmitSuccessful={fieldAdded}
                setSubmitSuccess={setFieldAdded}
                fillDetails={false}
                requirementFormClass="herorequirementFormClass"
                formType={openSource}
                setOpenSource={setOpenSource}
                formRef={formRef}
                handleItemAdd={handleItemAdd}
                setIsUpdated={setIsUpdated}
              />
            </div>
          </div>
        </div>
      )}
      {toastVisible && (
        <Toast
          text={successText}
          toastVisible={toastVisible}
          setToastVisible={setToastVisible}
          shouldReload={false}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  marketingNewsData: state.newsData.marketingNewsData,
  marketingCategories: state.newsData.marketingCategories,
  marketingSources: state.newsData.marketingSources,
});

const mapDispatchToProps = (dispatch) => ({
  getMarketingNews: () => dispatch(getMarketingNews()),
  createMarketingNews: (data) => dispatch(createMarketingNews(data)),
  getMarketingSourcesAndCategories: () => dispatch(getMarketingSourcesAndCategories()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsSubmissionForm);
